import { useQuery } from '@apollo/react-hooks'

import { IPaginationInput } from '../../types/common'
import { IGetCorporationTypesByAdminData } from '../../types/businesses'
import { GET_CORPORATION_TYPES_BY_ADMIN } from '../../queries/businesses'

export const useAllCorporationTypes = () => {
  const { data, ...q } = useQuery<IGetCorporationTypesByAdminData, { pagination: IPaginationInput }>(
    GET_CORPORATION_TYPES_BY_ADMIN,
    {
      variables: {
        pagination: { offset: 0, limit: 100 },
      },
      fetchPolicy: 'network-only',
    }
  )

  const corporationTypes = data?.getCorporationTypesByAdmin.data ?? []
  const total = data?.getCorporationTypesByAdmin.total ?? 0

  return {
    corporationTypes,
    total,
    ...q,
  }
}
